/** USPS tracking helpers. */

const USPS_TRACK_URL = 'https://tools.usps.com/go/TrackConfirmAction';

/** Splits user input into clean tracking numbers (spaces/dashes removed, uppercased). */
export function parseTrackingNumbers(input: string): string[] {
  return input
    .split(/[,;\n]+/)
    .map((n) => n.replace(/[\s-]/g, '').toUpperCase())
    .filter(Boolean);
}

/** USPS numbers: 20–22 digits (domestic), 26–34 digits (IMpb), or 2 letters + 9 digits + "US". */
export function isLikelyUspsNumber(n: string): boolean {
  return /^\d{20,22}$/.test(n) || /^\d{26,34}$/.test(n) || /^[A-Z]{2}\d{9}US$/.test(n) || /^9\d{15,33}$/.test(n);
}

/** USPS accepts up to 35 comma-separated labels in one lookup. */
export function uspsTrackingUrl(numbers: string[]): string {
  return `${USPS_TRACK_URL}?tLabels=${encodeURIComponent(numbers.slice(0, 35).join(','))}`;
}
